<template>
  <svg fill="none" height="18" viewBox="0 0 18 18" width="18">
    <path
      d="M12.3941 8.99998H8.99998M8.99998 8.99998H5.60587M8.99998 8.99998V5.60587M8.99998 8.99998V12.3941M14.6569 14.6569C11.5327 17.781 6.46734 17.781 3.34315 14.6569C0.218952 11.5327 0.218951 6.46734 3.34315 3.34315C6.46734 0.218952 11.5327 0.218952 14.6569 3.34315C17.781 6.46734 17.781 11.5327 14.6569 14.6569Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke-width="strokeWidth"
    />
  </svg>
</template>

<script>
  export default {
    name: 'PlusCircleIcon',

    props: {
      strokeWidth: {
        type: String,
        default: '2',
      },
    },
  };
</script>
